// Ghost.js - Specky's appearance using image

export const drawSpecky = (ctx, x, y, w, h, animationFrame, speckyImage, player) => {
  // Apply squash and stretch
  const squash = player?.squash || 1.0;
  const stretch = player?.stretch || 1.0;
  
  const drawW = w * stretch;
  const drawH = h * squash;
  
  // Center the stretched/squashed image
  const drawX = x + (w - drawW) / 2;
  const drawY = y + (h - drawH) / 2;
  
  if (speckyImage) {
    ctx.drawImage(speckyImage, drawX, drawY, drawW, drawH);
  } else {
    // Fallback to blue circle
    ctx.fillStyle = '#00D4FF';
    ctx.beginPath();
    ctx.arc(x + w/2, y + h/2, (w/2) * stretch, 0, Math.PI * 2);
    ctx.fill();
  }
};

export const getFloatOffset = (animationFrame) => {
  return Math.sin(animationFrame * 0.05) * 3;
};